import { PaginationModel } from '@cv-invision/cv.component-library.ux';

export class InboxFilterForm {
	address?: string;
	orderStates?: Array<any>;
	startDate?: Date;
	endDate?: Date;
	profileSelected?: any;
	pagination?: PaginationModel;
	referenceID?: string;
	inboxGlobalFilter: any;
	ssrFilterOrders?: any;
	formType?: Array<any>;
	clientName?: string;

	constructor() {
		this.address = '';
		this.orderStates = [];
		this.startDate = undefined;
		this.endDate = undefined;
		this.profileSelected = {};
		this.pagination = new PaginationModel();
		this.referenceID = undefined;
		this.inboxGlobalFilter = {};
		this.ssrFilterOrders = {};
		this.formType = [];
		this.clientName = '';
	}
}
